import { useCallback, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import { yupResolver } from '@hookform/resolvers/yup';
import { useAuth } from "_hooks";
import { Base } from "components/template";
import { InputControl } from "components/organism";
import { Button } from "components/atoms";
import { forgotSchema } from "_config/formSchemas";

const prefix = "v-forgot";

const Forgot = () => {
  const { forgot, forgotData, forgotIsLoading, forgotReset } = useAuth();
  const { handleSubmit, formState: { errors }, register } = useForm({
    resolver: yupResolver(forgotSchema)
  });
  const navigate = useNavigate();

  const onSubmit = ({ email }) => forgot(
    { account: email },
    { feedback: { error: true }}
  );

  const redirect = useCallback(() => {
    console.log("ejecutado")
    setTimeout(() => {
      navigate(`/account/login`);
    }, 1000);
  }, [navigate]);

  useEffect(() => {
    return () => {
      forgotReset();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (forgotData) redirect();
  }, [forgotData, redirect])

  return (
    <Base>
      <div className={`${prefix} flex flex-wrap flex-col p-3 mx-auto w-full sm:w-2/3 md:w-3/5 lg:w-4/12 max-w-[550px]`}>
        <div className="flex flex-wrap flex-col gap-6">
          <p className="text-center text-2xl font-bold mx-auto">Recuperar contraseña</p>
          <p className="text-center text-md">Te enviaremos un correo con instrucciones</p>

          <form onSubmit={handleSubmit(onSubmit)}>
            <InputControl 
              className="mb-10"
              errors={errors?.email}
              inputProps={{
                autoComplete: "off",
                placeholder: "Ej. nombre@tuempresa.com",
                ...register("email")
              }}
              label={"Correo electrónico"}
              orientation="vertical"
            />

            <Button
              className="bg-primary text-white rounded-lg"
              disabled={forgotData || forgotIsLoading}
              fullwidth
              height={10}
              pulse
            >Continuar</Button>

          </form>

          <span className="text-gray-800 w-full text-center">
            ¿Ya tienes una cuenta? <Link to="/account/login" className="underline">Iniciar sesión</Link>
          </span>

          <span className="text-gray-800 w-full text-center">
            ¿Aún no tienes cuenta? <Link to="/account/signup" className="underline">Regístrate</Link>
          </span>
        </div>
      </div>
    </Base>
  );
};

export default Forgot;
